/**
 * equalizeHeight jQuery plugin
 *
 * Sets every matched element to the height of the tallest one in its row,
 * so items across separate grid columns line up. Elements are grouped by
 * their vertical offset, so when cards wrap/stack (responsive) each visual
 * row is equalized independently. Re-runs on resize; safe to call repeatedly.
 *
 * Usage: $('.award-cards .card-header').equalizeHeight();
 */
(function ($) {
    'use strict';

    $.fn.equalizeHeight = function () {
        var $items = this;
        if (!$items.length) return $items;

        function resize() {
            // Clear any previous value so natural heights are measured.
            $items.css('height', '');

            var rows = {};
            $items.each(function () {
                // Group by rounded top offset so items on the same visual row
                // are equalized together (and stacked items are left alone).
                var top = Math.round($(this).offset().top);
                (rows[top] = rows[top] || []).push(this);
            });

            $.each(rows, function (_top, els) {
                var max = 0;
                $(els).each(function () {
                    max = Math.max(max, $(this).outerHeight());
                });
                $(els).css('height', max + 'px');
            });
        }

        resize();

        // Recalculate after fonts load (line-wrapping can shift) and on resize.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(resize);
        }

        // Images decode after DOM ready, changing element heights. Recalc when
        // any not-yet-loaded image inside (or among) the matched set finishes,
        // plus once more on full window load as a catch-all.
        $items.find('img').addBack('img').each(function () {
            if (!this.complete) {
                $(this).one('load.equalizeHeight', resize);
            }
        });
        $(window).on('load.equalizeHeight', resize);

        $(window).on('resize.equalizeHeight', debounce(resize, 150));

        return $items;
    };

    function debounce(fn, wait) {
        var t;
        return function () {
            clearTimeout(t);
            t = setTimeout(fn, wait);
        };
    }
})(jQuery);

export function equalizeHeights() {
    $('.award-cards .card-header').equalizeHeight();
    $('.award-cards .card-image').equalizeHeight();
}
